import Swiper from 'swiper/bundle';

import 'swiper/css/bundle';


const swiper = new Swiper('.homepage-slider', {
    direction: 'horizontal',
    loop: true,
    pagination: {
        el: '.homepage-pagination',
    },
    navigation: false,
    autoplay: {
        delay: 3500,
        disableOnInteraction: false,
    },
});